import { Query } from './query';

export class Criterion {

    alias: string;
    fieldName: string;
    condition: string;
    value: any;
    secondValue: any;
    noValue: boolean;
    singleValue: boolean;
    betweenValue: boolean;
    listValue: boolean;
    typeHandler: string;
    operator: string;

    private constructor() {
        this.singleValue = true;
        this.operator = Query.AND;
    }

    static isNull( alias: string, fieldName: string ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.IS_NULL;
        crit.noValue = true;
        crit.singleValue = false;

        return crit;
    }

    static isNotNull( alias: string, fieldName: string ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.IS_NOT_NULL;
        crit.noValue = true;
        crit.singleValue = false;

        return crit;
    }

    static equal( alias: string, fieldName: string, value: any ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.EQUAL;
        crit.value = value;

        return crit;
    }

    static notEqual( alias: string, fieldName: string, value: any ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.NOT_EQUAL;
        crit.value = value;

        return crit;
    }

    static greaterThan( alias: string, fieldName: string, value: any ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.GREATER_THAN;
        crit.value = value;

        return crit;
    }

    static greaterThanOrEqual( alias: string, fieldName: string, value: any ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.GREATER_THAN_OR_EQUAL;
        crit.value = value;

        return crit;
    }

    static lessThan( alias: string, fieldName: string, value: any ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.LESS_THAN;
        crit.value = value;

        return crit;
    }

    static lessThanOrEqual( alias: string, fieldName: string, value: any ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.LESS_THAN_OR_EQUAL;
        crit.value = value;

        return crit;
    }

    static like( alias: string, fieldName: string, value: any ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.LIKE;
        crit.value = value;

        return crit;
    }

    static notLike( alias: string, fieldName: string, value: any ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.NOT_LIKE;
        crit.value = value;

        return crit;
    }

    static between( alias: string, fieldName: string, valueFrom: any, valueTo: any ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.BETWEEN;
        crit.value = valueFrom;
        crit.secondValue = valueTo;
        crit.singleValue = false;

        return crit;
    }

    static notBetween( alias: string, fieldName: string, valueFrom: any, valueTo: any ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.NOT_BETWEEN;
        crit.value = valueFrom;
        crit.secondValue = valueTo;
        crit.singleValue = false;

        return crit;
    }

    static in( alias: string, fieldName: string, value: any[] ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.IN;
        crit.value = value;
        crit.singleValue = false;
        crit.listValue = true;

        return crit;
    }

    static notIn( alias: string, fieldName: string, value: any[] ): Criterion {
        let crit = new Criterion();
        crit.alias = alias;
        crit.fieldName = fieldName;
        crit.condition = Query.NOT_IN;
        crit.value = value;
        crit.singleValue = false;
        crit.listValue = true;

        return crit;
    }
    
    static custom( customCondition: string): Criterion {
        let crit = new Criterion();
        crit.fieldName = customCondition;
        crit.condition = Query.CUSTOM;
        crit.singleValue = false;
        crit.listValue = false;

        return crit;
    }
}
